package com.bikompanion.ui.composables

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.tooling.preview.Preview
import androidx.compose.ui.unit.dp
import com.bikompanion.domain.BikeStation
import com.bikompanion.ui.preview.PreviewEmptyStation
import com.bikompanion.ui.preview.PreviewStation
import com.bikompanion.ui.preview.PreviewSurface
import com.bikompanion.ui.strings.LocalStrings

/** A station's capacity split between normal bikes, electric bikes and empty slots. */
@Composable
internal fun StationAvailabilityBar(
    station: BikeStation,
    modifier: Modifier = Modifier,
) {
    AvailabilityBar(
        segments = listOf(
            AvailabilitySegment(LocalStrings.current.availabilityBikes, station.normalBikes, NormalBikeColor),
            AvailabilitySegment(LocalStrings.current.availabilityElectric, station.electricBikes, ElectricBikeColor),
            AvailabilitySegment(LocalStrings.current.availabilityEmpty, station.emptySlots, EmptySlotColor),
        ),
        total = (station.normalBikes + station.electricBikes + station.emptySlots)
            .coerceAtLeast(station.capacity),
        modifier = modifier,
    )
}

@Preview
@Composable
private fun StationAvailabilityBarPreview() {
    PreviewSurface {
        Column(
            modifier = Modifier.padding(16.dp),
            verticalArrangement = Arrangement.spacedBy(16.dp),
        ) {
            StationAvailabilityBar(station = PreviewStation)
            StationAvailabilityBar(station = PreviewStation.copy(electricBikes = 0))
            StationAvailabilityBar(station = PreviewStation.copy(emptySlots = 0))
            StationAvailabilityBar(station = PreviewEmptyStation)
        }
    }
}
